"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _IssueCard = _interopRequireDefault(require("@common/components/issues/IssueCard"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function IssueList(_ref) {
  var items = _ref.items,
    onItemClick = _ref.onItemClick,
    _ref$showCheckbox = _ref.showCheckbox,
    showCheckbox = _ref$showCheckbox === void 0 ? false : _ref$showCheckbox,
    selectedRuleUuids = _ref.selectedRuleUuids,
    onRuleSelectionChange = _ref.onRuleSelectionChange;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex flex-col gap-2",
    "data-sentry-component": "IssueList",
    "data-sentry-source-file": "IssueList.tsx",
    children: items.map(function (issue, index) {
      var _selectedRuleUuids$ha;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueCard.default, {
        issue: issue,
        onClick: onItemClick,
        showCheckbox: showCheckbox,
        isSelected: (_selectedRuleUuids$ha = selectedRuleUuids === null || selectedRuleUuids === void 0 ? void 0 : selectedRuleUuids.has(issue.ruleUuid || "")) !== null && _selectedRuleUuids$ha !== void 0 ? _selectedRuleUuids$ha : false,
        onSelectionChange: onRuleSelectionChange,
        filteredIndex: index
      }, issue.ruleUuid || index);
    })
  });
}
var _default = exports.default = IssueList;